import { render, staticRenderFns } from "./WxStoreOrder.vue?vue&type=template&id=d6f78e9c&scoped=true&"
import script from "./WxStoreOrder.vue?vue&type=script&lang=js&"
export * from "./WxStoreOrder.vue?vue&type=script&lang=js&"
import style0 from "./WxStoreOrder.vue?vue&type=style&index=0&id=d6f78e9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f78e9c",
  null
  
)

export default component.exports